var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDevices = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 69,
  height: 121,
  viewBox: "0 0 69 121",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_19281_2779)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.3252 0.5C62.8759 0.50013 67.3914 5.01603 67.3916 10.5674V20.4775H68.0996L68.1006 41.1162H67.3926V110.433C67.3926 115.985 62.876 120.501 57.3252 120.501H11.6748C6.12326 120.501 1.60742 115.984 1.60742 110.433V40.1719H0.899414V32.0557H1.60742V28.5947H0.899414V20.4775H1.60742V10.5674C1.60759 5.01603 6.12337 0.500136 11.6748 0.5H57.3252ZM11.6748 3.01758C7.51179 3.01771 4.12517 6.40445 4.125 10.5674V110.433C4.125 114.596 7.51168 117.983 11.6748 117.983H57.3252C61.4883 117.983 64.875 114.596 64.875 110.433V10.5674C64.8748 6.40445 61.4882 3.01771 57.3252 3.01758H11.6748ZM41.6152 6.00586C43.171 6.00595 44.4326 7.26745 44.4326 8.82324C44.4325 10.3789 43.1709 11.6396 41.6152 11.6396H27.3857C25.8299 11.6396 24.5685 10.3789 24.5684 8.82324C24.5684 7.26739 25.8298 6.00586 27.3857 6.00586H41.6152Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57 91C59.2091 91 61 92.7909 61 95V106C61 108.209 59.2091 110 57 110H12C9.79086 110 8 108.209 8 106V95C8 92.7909 9.79086 91 12 91H57ZM57 18C59.2091 18 61 20.3218 61 23.1855V82.8145C61 85.6782 59.2091 88 57 88H12C9.79086 88 8 85.6782 8 82.8145V23.1855C8 20.3218 9.79086 18 12 18H57Z",
  fill: "#D4E0F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2998 24V34H27.2998V24H14.2998ZM20.2326 32.8802H15.4212V25.1198H20.2326V32.8802ZM26.1654 32.8802H21.354V25.1198H26.1654V32.8802Z",
  fill: "#4585FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_19281_2779"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69,
  height: 121,
  fill: "white"
})))));
export default SvgIconDevices;